import React, { useEffect, useState } from 'react';
import { api } from '../../api';
import { Spinner, Alert } from '../../components/UI';

function formatDate(ts) {
  if (!ts) return '-';
  return new Date(ts).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function Reports() {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/reports/summary').then(setSummary).catch(e => setError(e.message));
  }, []);

  if (!summary && !error) return <Spinner />;
  const { overview, pass, byDepartment, byPaper } = summary || {};

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="eyebrow">Insights</div>
          <h1>Reports &amp; analytics</h1>
        </div>
        <button
          className="btn btn-primary"
          onClick={() => api.download('/reports/export.xlsx', 'report.xlsx').catch(e => setError(e.message))}
        >
          Export to Excel
        </button>
      </div>

      <Alert type="danger">{error}</Alert>

      <div className="stat-grid">
        <div className="stat-card"><div className="label">Attempts</div><div className="value">{overview?.attempts ?? 0}</div></div>
        <div className="stat-card"><div className="label">Average score</div><div className="value">{overview?.avg_score ?? '-'}</div></div>
        <div className="stat-card"><div className="label">Top score</div><div className="value">{overview?.top_score ?? '-'}</div></div>
        <div className="stat-card">
          <div className="label">Pass rate ({pass?.passing_percentage}%)</div>
          <div className="value">{pass?.total ? `${Math.round((pass.passed / pass.total) * 100)}%` : '-'}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><h3>Question papers</h3></div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Question paper</th>
                {/* <th>Added on</th> */}
                <th>Status</th>
                <th>Questions</th>
                <th>Attempts</th>
                {/* <th>Evaluated</th> */}
                {/* <th>Pending</th> */}
                <th>Average score</th>
                {/* <th>Average %</th> */}
                <th>Top score</th>
                {/* <th>Passed</th> */}
              </tr>
            </thead>
            <tbody>
              {(byPaper || []).map(p => (
                <tr key={p.id}>
                  <td className="text-sm text-muted">{formatDate(p.created_at)}</td>
                  <td>{p.title}</td>
                  <td className="text-sm text-muted">{p.status}</td>
                  <td className="mono">{p.question_count}</td>
                  <td className="mono">{p.attempts}</td>
                  <td className="mono">{p.avg_score ?? '-'}</td>
                  <td className="mono">{p.top_score ?? '-'}</td>
                </tr>
              ))}
              {(byPaper || []).length === 0 && (
                <tr><td colSpan={7} className="text-sm text-muted">No question papers yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-header"><h3>Department-wise average</h3></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Department</th><th>Scored</th><th>Max</th><th>Average %</th></tr></thead>
            <tbody>
              {(byDepartment || []).map(d => (
                <tr key={d.department}>
                  <td>{d.department}</td>
                  <td className="mono">{d.scored}</td>
                  <td className="mono">{d.max}</td>
                  <td className="mono">{d.avg_pct != null ? `${d.avg_pct}%` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* <div className="card mt-4">
        <div className="card-header"><h3>Hardest questions (lowest average score)</h3></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Question</th><th>Department</th><th>Answered</th><th>Avg %</th></tr></thead>
            <tbody>
              {(hardestQuestions || []).map(q => (
                <tr key={q.id}>
                  <td style={{ maxWidth: 400 }}>{q.question_text}</td>
                  <td className="text-sm text-muted">{q.department}</td>
                  <td className="mono">{q.answered}</td>
                  <td className="mono">{q.avg_pct != null ? `${q.avg_pct}%` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </div>
  );
}
